import { render, staticRenderFns } from "./AlisIrsaliyeEkAlanUpdate.vue?vue&type=template&id=5340ce67&"
import script from "./AlisIrsaliyeEkAlanUpdate.vue?vue&type=script&lang=js&"
export * from "./AlisIrsaliyeEkAlanUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports